import { render, staticRenderFns } from "./Layer3Pricing.vue?vue&type=template&id=147280a4&"
import script from "./Layer3Pricing.vue?vue&type=script&lang=js&"
export * from "./Layer3Pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports